import { Component, EventEmitter, Input, OnInit, Output, forwardRef } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { UtilsService } from '../../../../services/utils.service'

@Component({
    selector: 'app-form-simple-options-input',
    templateUrl: './form-simple-options-input.component.html',
    styleUrls: ['./form-simple-options-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FormSimpleOptionsInputComponent),
            multi: true,
        },
    ],
})
export class FormSimpleOptionsInputComponent implements OnInit, ControlValueAccessor {
    @Input() label = ''
    @Input() id = ''
    @Input() control!: any
    @Input() isReadOnly = false
    @Input() isRequired = false
    @Input() data: any[] = []
    @Input() selectedOption: any = null
    @Input() hideLabel = false
    @Input() forceNumeric = false
    @Input() useDefaultOption = true
    @Input() selectedContent: any
    @Output() getSelectedContent = new EventEmitter<any>()

    value: any

    public controlName = ''

    constructor(private readonly utils: UtilsService) {}

    ngOnInit(): void {
        this.controlName =
            this.utils.stringToKebabCase(this.utils.getControlName(this.control) ?? '') +
            '-select-input'
    }

    onChanged: (_: any) => void = () => {
        this.setSelectedContent(this.value)
    }

    onTouched: () => void = () => {}

    writeValue(value: any): void {
        this.value = value
    }

    registerOnChange(fn: any): void {
        this.onChanged = fn
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn
    }

    setDisabledState?(isDisabled: boolean): void {
        this.isReadOnly = isDisabled
    }

    setSelectedContent(contentToReturn: any) {
        this.selectedContent = contentToReturn
        this.getSelectedContent.emit(contentToReturn)
    }
}
